import React, { Fragment } from 'react';

// Components
import { Modal } from 'app-components';
import CustomFieldForm from '../forms/CustomFieldForm';

const CustomFieldModal = (props) => {
    const {
        modalData,
        modalData: {
            headerText,
            onClose
        },
        isDuplicate       
    } = props;
    return (
        <Fragment>
            <Modal id='custom_field_modal'>
                <Modal.Header id='custom_field_modal_title' titleId={headerText} onHide={onClose} />
                <Modal.Body>
                    <CustomFieldForm {...{ ...modalData,isDuplicate, onCancelHandler: onClose } }/>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default CustomFieldModal;
